import { Record } from "immutable";
import moment from "moment";

const defaults = {
    created_at_ms: undefined,
    created_by_user_id: undefined,
    customer_groups: [],
    description: "",
    hidden: true,
    id: undefined,
    linesheet_id: "",
    link: "",
    media: "",
    message: "",
    modified_at_ms: undefined,
    name: "",
    page_id: undefined,
    page_media_id: undefined,
};

interface IMedia {
    url: string;
    [param: string]: string;
}

export class LinesheetLink extends Record(defaults) {
    declare id: string;
    declare name: string;
    declare description?: string;
    declare link: string;
    declare message?: string;
    declare hidden: boolean;
    declare media: string;
    declare customer_groups: string[];
    declare linesheet_id: string;
    declare page_id: string;
    declare modified_at_ms: moment.Moment;
    declare created_at_ms: moment.Moment;
    declare created_by_user_id: string;
    declare page_media_id?: string;

    constructor(args) {
        super({
            ...args,
            created_at_ms: moment.utc(args.created_at_ms),
            modified_at_ms: moment.utc(args.modified_at_ms),
        });
    }
}

export interface ILinesheetLinkEntities {
    [id: string]: LinesheetLink;
}
